export const required = value => value ? undefined : 'Required';

export const email = value =>
    value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,5}$/i.test(value)
        ? 'Invalid email address'
        : undefined



// WEBPACK FOOTER //
// ./src/lib/validators.js